module.exports = __webpack_public_path__ + "static/img/49.68cfb36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/49.png
// module id = xnl9
// module chunks = 73